import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React from 'react'

const itemBlock = css`
  padding-top: 0px;
  padding-inline-end: 16px;
  padding-bottom: 16px;
  padding-inline-start: 16px;
  :hover {
    outline: 2px dashed ${colors.green30};
    outline-offset: -2px;
  }
`
const itemBlockNoHover = css`
  padding-top: 0px;
  padding-inline-end: 16px;
  padding-bottom: 16px;
  padding-inline-start: 16px;
`
const hiddenItemBlock = css`
  padding-top: 0px;
  padding-inline-end: 16px;
  padding-bottom: 16px;
  padding-inline-start: 16px;
  visibility: hidden;
`
const itemSelected = css`
  background: ${colors.transparent.green02};
  outline: 2px dashed ${colors.green30};
  outline-offset: -2px;
`

export default function ItemBlock({ selected, displayStatus, isSurvivingPerson, children }) {
  if (displayStatus === 'HIDDEN') {
    return (
      <div data-testid="hiddenItemBlock" css={hiddenItemBlock}>
        {children}
      </div>
    )
  }
  if (displayStatus === 'REMOVE') {
    return null
  }
  return (
    <div css={selected && itemSelected} data-testid="visibleItemBlock">
      <div css={isSurvivingPerson ? itemBlockNoHover : itemBlock}>{children}</div>
    </div>
  )
}
